import { SideBarContentType } from 'interfaces';
import { useState, useCallback } from 'react';

export const useSideBar = () => {
  const [isShown, setIsShown] = useState<boolean>(false);

  const [type, setType] = useState<SideBarContentType>(SideBarContentType.menu);

  const show = useCallback(() => {
    setIsShown(true);
  }, [isShown]);

  const hide = useCallback(() => {
    setIsShown(false);
  }, [isShown]);

  const toggle = useCallback(() => {
    setIsShown((state) => !state);
  }, [isShown]);

  const defineType = useCallback(
    (value: SideBarContentType) => {
      setType(value);
    },
    [type],
  );

  return {
    isSideBarOpen: isShown,
    sideBarContentType: type,
    openSideBar: show,
    closeSideBar: hide,
    toggleSideBar: toggle,
    setSideBarType: defineType,
  };
};
